import { Box, Typography } from '@mui/material';
import { BlockPreview } from './BlockPreview';
import type { Block } from './blocks';
import type { Catalog } from './useCatalog';
import type { StoreRateProjection } from './storeRateProjection';

/**
 * One market's composition rendered as an ordered stack of structural-honest block
 * representations (D-page-schema-editor-8c). `blocks` is null when the chosen facet
 * has nothing to show (the published facet of a never-published page): an honest
 * empty state, NOT a fabricated render. Blocks render in authored order, ALL of them
 * regardless of any schedule (per-block scheduling is 8d; there is no as-of-now
 * filter here). `projection` (8c-boost) feeds each store card its tier-labelled
 * projected rate; it is per-market (the caller bakes in this column's market).
 */
export const PagePreview = ({
  blocks,
  catalog,
  testId,
  projection,
}: {
  blocks: Block[] | null;
  catalog: Catalog;
  testId?: string;
  projection?: StoreRateProjection;
}) => {
  if (blocks === null) {
    return (
      <Typography
        variant="body2"
        color="text.secondary"
        data-testid={testId ? `${testId}-empty` : undefined}
      >
        Not yet published.
      </Typography>
    );
  }
  if (blocks.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No blocks in this composition.
      </Typography>
    );
  }
  return (
    <Box data-testid={testId}>
      {blocks.map((block) => (
        <BlockPreview
          key={block.id}
          block={block}
          catalog={catalog}
          projection={projection}
        />
      ))}
    </Box>
  );
};
